import React, { useState } from "react"
import { Link, useHistory, useLocation } from "react-router-dom"
import InputField from "../../components/InputField/InputField"
import Navbar from "../../components/Navbar/Navbar"
import Arrow from "../../assets/Green-right-arrow.svg"
import { useToasts } from "react-toast-notifications"
import dayjs from "dayjs"
import {
  getApiErrorMessage,
  setTokenToStorage,
  setExpiryTimeToStorage
} from "../../utils/ApiUtils"
import { login } from "../../utils/ApiRequests"
import MiniLoader from "../../components/Loaders/MiniLoader"

const Login = () => {
  const [loginForm, setLoginForm] = useState({})
  const [loading, setLoading] = useState(false)
  const { addToast } = useToasts()
  const history = useHistory()
  const date = dayjs().add(7, "days")
  const location = useLocation()

  const handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setLoginForm({ ...loginForm, ...newEntry })
  }

  const loginAction = e => {
    e.preventDefault()
    setLoading(true)
    login({
      email: loginForm?.email,
      password: loginForm?.password
    })
      .then(res => {
        setLoading(false)
        setTokenToStorage(res.data?.data.token)
        setExpiryTimeToStorage(date)
        addToast(res.data?.message, { appearance: "success" })
        history.push("/dashboard")
      })
      .catch(error => {
        setLoading(false)
        addToast(getApiErrorMessage(error.response), {
          appearance: "error"
        })
      })
  }

  return (
    <section className="global-container relative min-h-screen min-w-full">
      <Navbar />

      <form
        onSubmit={loginAction}
        className="w-3/5 max-w-xl mx-auto px-12 py-10 mt-20 shadow-lg tablets:w-full tablets:px-5"
      >
        <h1 className="text-center text-xl mb-10">Log in to Sabigift</h1>

        <InputField
          label="Email"
          id="email"
          htmlFor="email"
          placeholder="Enter email address here"
          name="email"
          handleChange={handleChange}
          required
          type="email"
        />

        <InputField
          label="Password"
          placeholder="Enter your password here"
          id="password"
          htmlFor="password"
          name="password"
          type="password"
          handleChange={handleChange}
          required
        />

        {loading ? (
          <MiniLoader />
        ) : (
          <button
            type="submit"
            className="w-full py-3 text-center text-white bg-sbg-light-green font-medium text-xl focus:outline-none"
          >
            Log in
          </button>
        )}

        <h3 className="flex mt-8 w-full justify-center items-center flex-wrap">
          Forgot your password?
          <Link
            to="reset-password"
            className="ml-2 text-lgreen flex items-center"
          >
            Reset your password{" "}
            <img src={Arrow} alt="reset password" className="inline ml-2.5" />
          </Link>
        </h3>

        <h3 className="flex mt-4 w-full justify-center items-center">
          Don't have an account?
          <Link to="/sign-up" className="ml-2 text-lgreen flex items-center">
            Sign Up <img src={Arrow} alt="sign up " className="inline ml-2.5" />
          </Link>
        </h3>

        <h4 className="text-sm text-center mt-6 text-grey">
          This site is protected by reCAPTCHA and the Google Privacy Policy and
          <br />
          Terms of Service apply.
        </h4>
      </form>
    </section>
  )
}

export default Login
